import React from 'react';
import { graphql } from 'gatsby';

import BannerNewsletterSectionDS from 'design-system/src/components/organisms/BannerNewsletterSection';
import { getImage } from '../../utils/media';

export default function BannerNewsletterSection({
    media,
    brochureImage,
    ...props
}: any) {
    return (
        <BannerNewsletterSectionDS
            {...props}
            media={getImage(media)}
            brochureImage={getImage(brochureImage)}
        />
    );
}

export const query = graphql`
    fragment DatoCmsBannerNewsletterSection on DatoCmsBannerNewsletterSection {
        title
        titleTag
        text
        media: backgroundImage {
            ...SourceMedia
            gatsbyImageData(width: 1508, placeholder: BLURRED)
        }
        brochureImage {
            ...SourceMedia
            gatsbyImageData(
                width: 464
                placeholder: BLURRED
                imgixParams: { w: "464" }
            )
        }
        form {
            ...Form
        }
    }
`;
